<template>
    <div>
        <AdminSelect
            :id="props.id"
            v-model="modelValue"
            :options="options"
            :dusk="props.dusk"
            :size="props.size"
            :multiple="field.multiple"
            :orderable="field.orderable"
            :searchable="isSearchable"
        >
            <template #currentValue="slotProps">
                <slot name="currentValue" v-bind="slotProps"></slot>
            </template>
            <template #selectedItem="slotProps">
                <slot name="selectedItem" v-bind="slotProps"></slot>
            </template>
            <template #option="slotProps">
                <slot name="option" v-bind="slotProps"></slot>
            </template>
            <template #optionsBefore="slotProps">
                <slot name="optionsBefore" v-bind="slotProps"></slot>
            </template>
            <template #optionsAfter="slotProps">
                <slot name="optionsAfter" v-bind="slotProps"></slot>
            </template>
        </AdminSelect>
    </div>
</template>

<script setup lang="ts">
import { toRefs, ref, computed } from 'vue';
import type { FieldComponent } from '@src/Common/Components/types';

const modelValue = defineModel({
    type: [String, Number, Array, Object],
});

const props = withDefaults(defineProps<FieldComponent>(), {
    options: () => [],
    dusk: null,
    searchable: false,
});

const { field } = toRefs(props);

const options = ref([]);

const addNullOption = () => {
    if (!field.value.multiple && field.value.nullable) {
        options.value.unshift({
            name: field.value.null ?? 'None',
            id: null,
        });
    }
};

const isSearchable = computed(() =>
    field.value.searchable ? field.value.searchable || props.searchable : props.searchable,
);

const load = () => {
    // Route is not defined, assume it's a contentable field
    if (!field.value.route) {
        axios.get(route('contentable.admin.api.contentables', { slug: field.value.contentable })).then(({ data }) => {
            options.value = data.items
                ?.filter((contentable) => parseInt(contentable.id, 10) !== parseInt(route().params?.id, 10))
                .map((contentable: any) => ({
                    name: contentable.title,
                    id: `${contentable.id}`,
                }));

            addNullOption();
        });
    } else {
        axios.get(field.value.route).then(({ data }) => {
            options.value = data;

            addNullOption();
        });
    }
};

load();

/**
 * Reload field
 */
const reload = () => {
    load();
};

defineExpose({ reload });
</script>
